module.exports = __webpack_public_path__ + "static/media/staffimg3.7907a395.png";